import { getElements } from '../Utility/Dom'

class BrevoForm {
  private readonly emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  private forms: NodeListOf<HTMLElement>

  constructor() {
    this.forms = getElements('brevo-form')
  }

  public init(): void {
    const email = new URLSearchParams(window.location.search).get('email')

    if (!email || !this.emailPattern.test(email)) {
      return
    }

    this.forms.forEach((form: HTMLElement): void => {
      const emailInput = form.querySelector<HTMLInputElement>('input[type="email"]')

      if (emailInput) {
        emailInput.value = email
      }
    })
  }
}

const brevoForm = new BrevoForm()
brevoForm.init()
